import { StandardRatesOfPenetrationBase } from './base/standard-rates-of-penetration-base';

export class StandardRatesOfPenetration extends StandardRatesOfPenetrationBase { }